export const MODEL = {
  USER: 'User',
  CLIENT: 'Client'
};

export const USER_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated'
};

// Max length of the recommendations/notes field on report sign-offs. Matches the varchar length
// of the check_sheet_report.notes column — keep the two in lockstep. Consider increasing this and
// changing the database column to text if users need to enter longer notes.
export const RECOMMENDATIONS_MAX_LENGTH = 255;
